import React from "react";
import { Flex } from "@radix-ui/themes";
import claudeLogo from "../../../assets/icons/claude-ai-logo.png";

export function ClaudeMark({ size = 40 }) {
  return (
    <Flex
      align="center"
      justify="center"
      aria-label="Claude"
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        padding: size * 0.15,
        boxSizing: "border-box",
        borderRadius: "var(--space-1)",
        background: "#FFFFFF",
        border: "1px solid var(--gray-a6)",
      }}
    >
      <img
        src={claudeLogo}
        alt="Claude"
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </Flex>
  );
}
